import Button from '@jetbrains/ring-ui/components/button/button'
import type {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import classNames from 'classnames'
import type {ReactNode} from 'react'
import {memo} from 'react'

import SvgIcon from '../../../library/components/SvgIcon/SvgIcon'
import DarkPopup from '../DarkPopup/DarkPopup'

import styles from './NewFeaturePopup.css'

interface Props {
  directions?: Directions[]
  className?: string
  title: ReactNode
  description: ReactNode
  onClose: () => void
  top?: number
  target?: string | Element | null
}

function NewFeaturePopup(props: Props) {
  const {title, description, onClose, className, directions, top, target} = props
  return (
    <DarkPopup
      directions={directions}
      top={top}
      target={target}
      className={classNames(styles.tooltip, className)}
    >
      <div className={styles.container} data-test={'new-feature-popup'}>
        <SvgIcon icon="gift" />
        <div className={styles.info}>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{description}</div>
          <Button data-test={'got-id'} className={styles.button} primary onClick={onClose}>
            {'Got it'}
          </Button>
        </div>
      </div>
    </DarkPopup>
  )
}

export default memo(NewFeaturePopup)
